var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallWhiteLogoAprobank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Marca_branco",
    "data-name": "Marca branco",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 344.097,
    height: 123.586,
    viewBox: "0 0 344.097 123.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_485",
    "data-name": "Ret\\xE2ngulo 485",
    width: 344.097,
    height: 123.586,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_506",
    "data-name": "Grupo 506",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1233",
    "data-name": "Caminho 1233",
    d: "M84.925,43.435a5.692,5.692,0,0,0-.072-8.083L50.508,1.617A5.771,5.771,0,0,0,46.484,0a5.7,5.7,0,0,0-5.676,5.748l.228,24.706L1.648,70.559a5.692,5.692,0,0,0,.072,8.083l34.345,33.7a5.636,5.636,0,0,0,3.952,1.653,6.407,6.407,0,0,0,2.3-.467A5.632,5.632,0,0,0,45.8,108.21L45.574,83.5ZM44.831,5.712a1.683,1.683,0,0,1,1.042-1.581,1.606,1.606,0,0,1,1.8.323L82.015,38.19a1.7,1.7,0,0,1,.036,2.407L45.521,77.808,45.047,26.37l-.03.031ZM41.778,108.282a1.654,1.654,0,0,1-.467,1.186,1.7,1.7,0,0,1-2.407.036L4.558,75.768a1.7,1.7,0,0,1-.036-2.407L41.088,36.113l.475,51.475.02-.02Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1234",
    "data-name": "Caminho 1234",
    d: "M189.4,174.3c-5.64,0-9.3,3.377-11.029,10.167l-9.987,37.255h7.006l3.629-13.544h20.8l3.629,13.544h7.042l-10.059-37.255c-1.689-6.79-5.389-10.167-11.029-10.167m-8.514,27.088,4.527-16.921c.647-2.263,2.012-3.377,4.024-3.377s3.377,1.114,4.024,3.377l4.527,16.921Z",
    transform: "translate(-107.893 -111.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1235",
    "data-name": "Caminho 1235",
    d: "M325.453,225.544q0-13.526-13.544-13.544h-3.377q-13.526,0-13.544,13.544v33.878h6.79V245.878h10.167c9.017,0,13.544-4.491,13.544-13.544h-.036Zm-6.754,6.79q0,6.79-6.79,6.79l-10.167-.036V225.544c0-4.491,2.263-6.754,6.79-6.754h3.377c4.527,0,6.79,2.227,6.79,6.754Z",
    transform: "translate(-189.01 -135.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1236",
    "data-name": "Caminho 1236",
    d: "M396.088,225.544v20.334h6.79V225.544c.036-4.491,2.263-6.754,6.754-6.754H419.8V212H409.632q-13.526,0-13.544,13.544",
    transform: "translate(-253.789 -135.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1237",
    "data-name": "Caminho 1237",
    d: "M482.545,212h-3.413q-13.526,0-13.544,13.544v6.79q0,13.526,13.58,13.544h3.377c9.018,0,13.544-4.491,13.544-13.544v-6.79c0-9.017-4.491-13.544-13.544-13.544m6.754,20.334q0,6.79-6.79,6.79h-3.377q-6.79,0-6.79-6.79v-6.79c0-4.491,2.263-6.754,6.79-6.754h3.377c4.527,0,6.79,2.227,6.79,6.754Z",
    transform: "translate(-298.32 -135.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1238",
    "data-name": "Caminho 1238",
    d: "M583.909,187.844H573.742V174.3h-6.754v33.878q0,13.526,13.544,13.544h3.377c9.017,0,13.544-4.491,13.544-13.544v-6.79c0-9.017-4.491-13.544-13.544-13.544m6.79,20.334q0,6.79-6.79,6.79h-3.377q-6.79,0-6.79-6.79V194.634h10.167c4.527,0,6.79,2.227,6.79,6.754Z",
    transform: "translate(-363.291 -111.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1239",
    "data-name": "Caminho 1239",
    d: "M679.209,212.1H665.665v6.754h13.544c4.527,0,6.79,2.227,6.79,6.754H675.832q-13.526,0-13.544,10.167,0,10.185,13.544,10.167v.036h3.377c9.017,0,13.544-4.491,13.544-13.544v-6.79c0-9.017-4.491-13.544-13.544-13.544m0,27.052h-3.377c-4.527,0-6.79-1.114-6.79-3.377,0-2.227,2.263-3.377,6.79-3.413H686q0,6.79-6.79,6.79",
    transform: "translate(-424.353 -135.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1240",
    "data-name": "Caminho 1240",
    d: "M780.209,212h-3.377q-13.526,0-13.544,13.544v20.334h6.79V225.544c0-4.491,2.263-6.754,6.79-6.754h3.377c4.527,0,6.79,2.227,6.79,6.754v20.334h6.79V225.544q0-13.526-13.616-13.544",
    transform: "translate(-489.068 -135.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1241",
    "data-name": "Caminho 1241",
    d: "M901.083,187.844h-9.556l-13.544,13.544h-1.94V174.3h-6.754v47.423h6.754V208.214h1.94l13.544,13.544h9.556L884.126,204.8Z",
    transform: "translate(-556.986 -111.681)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWhiteLogoAprobank);
export default __webpack_public_path__ + "static/media/smallWhiteLogoAprobank.d9064bf9d3f6c687b0a4caa7fdf47cfb.svg";
export { ForwardRef as ReactComponent };